module.exports = __webpack_public_path__ + "static/media/cover.905fa5e3.png";